import { AbstractControl, FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { DuplicateCommRecord } from "@app/models";
import { Timezone } from "@app/models/organization.model";
import { FORM_REGEX, COMM_TYPES, GENERAL_MESSAGES, DEFAULT_TIMEZONE } from "@app/shared";
import * as _moment from 'moment-timezone';
const moment = _moment;

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isAddMode: boolean = false;
  constructor(isAddMode: boolean) {
    this.isAddMode = isAddMode;
  }
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    let result: boolean;
    if (!this.isAddMode)
      result = (control?.invalid) ? true : false;
    else
      result = (control && control.touched && control.invalid) ? true : false;
    return result;
  }
}

export function phoneNumberValidator(isrequired: boolean = false) {
  return (control: AbstractControl) => {
      if (control.value) {
          const val = control.value.phone;
          let regex = new RegExp(FORM_REGEX.phone_no);
          if (!val?.length && isrequired) {
              control.markAsDirty();
              return { required: true };
          } else if (val?.length > 0 && !regex.test(val)) {
              control.markAsDirty();
              return { pattern: true };
          } else return null;
      } else {
          if (isrequired) {
              control.markAsDirty();
              return { required: true };
          }
          return null;
      }
  };
}


export class DuplicateCommunicationData {
  broadcast_id?: DuplicateCommRecord[];
  survey_ids?: DuplicateCommRecord[];
  timeZone: Timezone = DEFAULT_TIMEZONE;
  warnList: {value: string; isErrorType?: boolean; list?: string[]; buttonMessage?: string, data?: any, name?: string} = {
    value: GENERAL_MESSAGES.DUPLICATE_COM_MSG, 
    isErrorType: false, 
    buttonMessage: 'VIEW DETAILS',
    list: [],
    data: {
      broadcasts: [],
      surveys: []
    },
    name: 'COMMS_DUPLICATE'
  };

  constructor(
    timeZone: Timezone | null, 
    data?: {
      broadcast_id?: DuplicateCommRecord[],
      survey_ids?: DuplicateCommRecord[]
    }
  ) {
    this.broadcast_id = data?.broadcast_id;
    this.survey_ids = data?.survey_ids;
    if (timeZone) this.timeZone = timeZone;
    this.parseDuplicateWarnData()
  }
  
  /**Conversion function for Duplicate communication error data */
  parseDuplicateWarnData() {
    let warnListValues: string[] = [];
    this.warnList.data = {
      broadcasts: [],
      surveys: []
    };
    if (this.broadcast_id?.length || this.survey_ids?.length) {
      if (this.broadcast_id?.length) {
        this.broadcast_id.forEach(broadcastDup => {
          this.warnList.data.broadcasts.push(broadcastDup);
          warnListValues.push(`Broadcast ID ${broadcastDup.id}, ${this.getCommType(broadcastDup)}`);
        });
      }
      if (this.survey_ids?.length) {
        this.survey_ids.forEach(surveyDup => {
          this.warnList.data.surveys.push(surveyDup);
          warnListValues.push(`Survey ID ${surveyDup.id},${surveyDup.run_id ? ' Run ID ' + surveyDup.run_id + ', ' : ''} ${surveyDup.name || ''} ${this.getCommType(surveyDup)}`);
        });
      }
    }
    this.warnList = {
      ...this.warnList, 
      list: warnListValues,
    };

    return this.warnList;
  }

  private getCommType(record: DuplicateCommRecord) {
    switch (record.comm_type) {
      case COMM_TYPES.broadcastSch: 
      case COMM_TYPES.surveyFirstRunSch: 
      case COMM_TYPES.surveyRerunSch: 
        return `${this.getTimeString(record.schedule_time)} (scheduled).`;
    
      default:
        return `${this.getTimeString(record.sent_date)} (sent).`;
    }
  }

  private getTimeString(utcValue: string, ) {
    return moment.tz(utcValue, this.timeZone.timezone_identifier).format('ddd MM/DD/YY hh:mm A');
  }
};